module.exports = {
    APP_VERSION: '1.6.1',
};
